<template>
  <div class="content-wrapper">    
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Link Management
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>Link</li>
        <li class="active">Link List</li>
      </ol>      
    </section>

    <!-- Main content -->
    <section class="content">   
      <div class="row">
        <div class="col-md-12">
          <div class="box box-default margin-bottom-0px">
            <div class="box-header with-border">
              <h3 class="box-title">Link List</h3>
              <div class="action-button pull-right">  
                <div class="form-group col-xs-12 col-sm-12" style ="margin-top: 20px;">
                  <label for="date-to"></label>
                  <router-link class="btn btn-primary" :to="`Link-addOrUpdate`">Add Link</router-link>
                </div>
              </div>
            </div>
              <!-- /.box-header -->
            <div class="loader" v-if="actionInProgress">
              <img src="/static/assets/loader/nivi-loader.svg" />
            </div>
            <div class="box-footer no-border">
              <div class="row">
                <div class="col-md-12">
                  <vue-good-table
                    mode="remote"
                    styleClass="vgt-table good-table condensed striped"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :columns="columns"
                    :rows="linkData"
                    :totalRows="linkDataCount"
                     :pagination-options="{
                        enabled: true,
                        perPage: tableQueryParams.perPage,
                        setCurrentPage: tableQueryParams.page
                    }">
                    <div slot="emptystate"><nv-empty-state icon="fa-link" title="No links found" hint="Try changing the filters, or create a new link." action-label="Create link" action-to="/link-addOrUpdate" /></div>
                      <template slot="loadingContent">
                        <!-- Empty loading screen to disable default loading -->
                      </template>
                      <template slot="table-row" slot-scope="props">
                        <slot :props="props" />

                        <span v-if="props.column.field == 'createdAt'">
                          {{formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')}}
                        </span>
                        <span v-else-if="props.column.field == 'updatedAt'">
                          {{formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')}}
                        </span>
                        <span v-else-if="props.column.field == 'is_active'">
                          <span v-if="props.formattedRow[props.column.field]" class="badge badge-pill btn-success"  style="cursor:pointer" v-on:click="showDeleteConfirmationPopup(props.row, props.index)">Active</span>
                          <span v-if="!props.formattedRow[props.column.field]" class="badge badge-pill btn-danger"  style="cursor:pointer" v-on:click="showDeleteConfirmationPopup(props.row, props.index)">Inactive</span>
                        </span>
                        
                        <span v-else-if="props.column.field == 'copy'">
                          <input type="button" class="btn btn-primary btn-sm" @click="copyLink(props.row)" value="Copy URL">
                        </span>
                        <span v-else-if="props.column.field == 'edit'">
                          <router-link :to="`Link-addOrUpdate?linkId=${props.row.id}`">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                          </router-link>
                        </span>
                        <span v-else>{{props.formattedRow[props.column.field]}}</span>
                        
                      </template>    
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>  
      </div>       
    </section>
    
      <deleteConfirmationModal
        v-if="isDeleteConfirmationVisible"        
        @close="closeConfirmationModal" 
        @deleteLink="deleteLink"
        @deactiveLink="deactiveLink"
        @activeLink="activeLink"
        :isDeleteConfirmationVisible="isDeleteConfirmationVisible"
        :confirmationMessage="confirmationMessage" 
        :actionToBePerformed="actionToBePerformed"
        />
    <div class="pagination-container">
      <paginate v-if="pageCount > 0" v-model="page" :page-count="pageCount" :click-handler="getDataForSelectedPage" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination'"></paginate>
    </div> 
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>   
  </div>  
  
</template>
<script>
import _ from 'lodash'
import moment from 'moment'
import Paginate from 'vuejs-paginate'
import flatPickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.css'
import api from '../../../utils/api'
import deleteConfirmationModal from './../popup/deleteConfirmation'
import { formatDate, getSelectorValue } from '../../../utils/utilities'
import { domain } from './../../../config/constants'

export default {
  name: 'KeywordDashboard',
  components: {
    'deleteConfirmationModal': deleteConfirmationModal,
    'paginate': Paginate,
    flatPickr
  },
  async mounted () {
    flatPickr('input[placeholder="Select Date Range', {
      dateFormat: 'd-m-Y',
      mode: 'range',
      allowInput: true,
      onClose: function (selectedDates, dateStr, instance) {
        if (selectedDates.length === 1) {
          instance.setDate([selectedDates[0], selectedDates[0]], true)
        }
      }
    })
    await this.getAllLink()
  },
  data () {
    return {
      pageCount: 0,
      linkDataCount: 0,
      currentPage: 1,
      pageSize: 20,
      formatDate: formatDate,
      linkSearchResult: [],
      keywordObj: {},
      searchLink: '',
      loading: false,
      actionInProgress: false,
      isModalVisible: false,
      isDeleteConfirmationVisible: false,
      validationErrors: [],
      linkData: [],
      clonedlinkData: [],
      actionToBePerformed: 'Add Link',
      confirmationMessage: 'Are you sure you want to delete this link?',
      rowIndexToBeUpdated: 0,
      dateRange: '',
      countFromDate: '',
      countToDate: '',
      countDateFilterChanged: false,
      countDateFilterParams: {},
      tableQueryParams: {
        columnFilters: {},
        sort: {
          createdAt: 'desc'
        },
        page: 1,
        perPage: 20
      },
      columns: [
        {
          label: 'Link Name',
          field: 'name',
          sortable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Search Link Name'
          }
        },
        {
          label: 'Created Date',
          field: 'createdAt',
          sortable: true,
          filterable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Select Date Range'
          }
        },
        {
          label: 'Last Edit Date',
          sortable: true,
          field: 'updatedAt',
          filterable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Select Date Range'
          }
        },
        {
          label: 'Status',
          field: 'is_active',
          sortable: false
        },
        {
          label: 'Copy URL',
          field: 'copy',
          sortable: false
        },
        {
          label: 'Edit',
          field: 'edit',
          sortable: false
        },
        {
          label: 'Clicks',
          field: 'count',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Select Date Range'
          }
        }
      ],
      previousQueryParams: {}
    }
  },
  methods: {
    updateParams (newProps) {
      this.tableQueryParams = {...this.tableQueryParams, ...newProps}
    },
    onPageChange (params) {
      this.updateParams({page: params.currentPage})
      this.getAllLink()
    },
    onPerPageChange (params) {
      this.updateParams({perPage: params.currentPerPage})
      this.getAllLink()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          [this.columns[params.columnIndex].field]: params.sortType
        }
      })
      this.getAllLink()
    },
    onColumnFilter (params) {
      let appliedFilter = {}
      for (const key in params.columnFilters) {
        if (key === 'createdAt') {
          const filterDates = params.columnFilters[key].split(' to ')
          if (filterDates.length && filterDates[0]) {
            appliedFilter['fromDt'] = moment(filterDates[0], 'DD/MM/YYYY').startOf('day').utc(true)
            appliedFilter['toDt'] = moment(filterDates[1] || filterDates[0], 'DD/MM/YYYY').endOf('day').utc(true)
          }
        } else if (key === 'updatedAt') {
          const filterDates = params.columnFilters[key].split(' to ')
          if (filterDates.length && filterDates[0]) {
            appliedFilter['editFromDt'] = moment(filterDates[0], 'DD/MM/YYYY').startOf('day').utc(true)
            appliedFilter['editToDt'] = moment(filterDates[1] || filterDates[0], 'DD/MM/YYYY').endOf('day').utc(true)
          }
        } else if (key === 'count') {
          const filterDates = params.columnFilters[key].split(' to ')
          if (filterDates.length && filterDates[0]) {
            this.countFromDate = moment(filterDates[0], 'DD/MM/YYYY').startOf('day').utc(true)
            this.countToDate = moment(filterDates[1] || filterDates[0], 'DD/MM/YYYY').endOf('day').utc(true)
            this.countDateFilterChanged = true
          } else {
            this.countFromDate = ''
            this.countToDate = ''
            this.countDateFilterChanged = false
          }
        } else if (params.columnFilters[key]) {
          appliedFilter[key] = params.columnFilters[key]
        }
      }
      this.updateParams({columnFilters: appliedFilter})
      this.getAllLink()
    },

    copyLink (linkObj) {
      var domainname = window.location.hostname
      var clickUrlDomain = domain[domainname].clickUrlDomain
      var node = document.createElement('textarea')
      node.innerHTML = `${clickUrlDomain}${linkObj.code}`
      document.body.appendChild(node)
      node.select()
      try {
        var success = document.execCommand('copy')
        success ? this.$swal({
          type: 'success',
          title: 'Link Copied to clipboard!',
          showConfirmButton: false,
          timer: 1000
        }) : null
        success ? console.log('copy successful') : console.log('copy unsuccessful')
      } catch (e) {
        console.log('browser not compatible')
      }
      document.body.removeChild(node)
    },
    /**
     * @function closeConfirmationModal
     * @description Function to close delete confirmation popup
     */
    closeConfirmationModal () {
      this.isDeleteConfirmationVisible = false
      var self = this
      setTimeout(function () {
        self.actionToBePerformed = 'Add Keyword'
      }, 500)
    },
    /**
     * @function closeModal
     * @description Function to close modal and reset all the variables
     */
    showDeleteConfirmationPopup (linkData, index) {
      if (linkData.is_active) {
        this.actionToBePerformed = 'Deactivate Link'
        this.confirmationMessage = 'Are you sure you want to Deactivate this Link?'
      } else {
        this.actionToBePerformed = 'Activate Link'
        this.confirmationMessage = 'Are you sure you want to Activate this Link?'
      }
      this.isDeleteConfirmationVisible = true
      this.rowIndexToBeUpdated = index
    },

    async getAllLink () {
      let queryParams = {
        skip: this.tableQueryParams.perPage * (this.tableQueryParams.page - 1),
        limit: this.tableQueryParams.perPage,
        sort: this.tableQueryParams.sort,
        selector: getSelectorValue(this.tableQueryParams.columnFilters)
      }

      let countParams = this.countDateFilterChanged ? {
        countFromDt: this.countFromDate,
        countToDt: this.countToDate
      } : {}

      if (JSON.stringify(this.previousQueryParams) === JSON.stringify(queryParams) && JSON.stringify(this.countDateFilterParams) === JSON.stringify(countParams)) {
        return
      } else if (JSON.stringify(this.previousQueryParams.selector) !== JSON.stringify(queryParams.selector) || JSON.stringify(this.previousQueryParams.sort) !== JSON.stringify(queryParams.sort)) {
        queryParams.skip = 0
        this.tableQueryParams.page = 1
      }
      this.loading = true
      api.buildRequest('getLinkList', 'POST', {...queryParams, ...countParams})
          .then(response => {
            this.loading = false
            if (response.status === 200) {
              this.previousQueryParams = queryParams
              this.countDateFilterParams = countParams
              this.linkData = response.data.payload.link
              this.linkDataCount = response.data.payload.linkCount
            } else {
              this.$swal({
                type: 'error',
                text: 'An error occurred'
              })
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    closeModal () {
      console.log('inside closeModal function')
      this.rowIndexToBeUpdated = 0
      this.isModalVisible = false
      this.isDeleteConfirmationVisible = false
      this.validationErrors = []
      var self = this
      setTimeout(function () {
        self.actionToBePerformed = 'Add Keyword'
      }, 500)
    },
    deleteLink () {
      this.loading = true
      console.log('deleteLink')
      console.log('index')
      console.log(this.rowIndexToBeUpdated)
      const deletedRowData = this.linkData[this.rowIndexToBeUpdated]
      this.linkData.splice(this.rowIndexToBeUpdated, 1)
      console.log('spliced linkData')
      console.log(this.linkData)
      const params = deletedRowData
      var self = this
      api.buildRequest('deleteLink', 'POST', params)
          .then(response => {
            self.loading = false
            self.rowIndexToBeUpdated = 0
            self.closeModal()
            if (response.status === 200) {
              self.isDeleteConfirmationVisible = false
              this.$swal({
                type: 'success',
                text: response && response.data && response.data.payload && response.data.payload.message ? response.data.payload.message : 'Link deleted successfully'
              })
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            self.closeModal()
            self.rowIndexToBeUpdated = 0
            self.isDeleteConfirmationVisible = false
            self.actionInProgress = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    deactiveLink () {
      this.isDeleteConfirmationVisible = false
      this.loading = true
      console.log('deactiveLink')
      console.log('index')
      console.log(this.rowIndexToBeUpdated)
      const deletedRowData = this.linkData[this.rowIndexToBeUpdated]
      deletedRowData.is_active = false
      // this.linkData.splice(this.rowIndexToBeUpdated, 1)
      // console.log('spliced linkData')
      console.log(this.linkData)
      const params = deletedRowData
      var self = this
      api.buildRequest('deactivatedLink', 'POST', params)
          .then(response => {
            self.loading = false
            self.rowIndexToBeUpdated = 0
            if (response.status === 200) {
              self.isDeleteConfirmationVisible = false
              this.$swal({
                type: 'success',
                text: response && response.data && response.data.payload && response.data.payload.message ? response.data.payload.message : 'Link deactivated successfully'
              })
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            self.closeModal()
            self.rowIndexToBeUpdated = 0
            self.isDeleteConfirmationVisible = false
            self.actionInProgress = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    activeLink () {
      this.isDeleteConfirmationVisible = false
      this.loading = true
      console.log('activeLink')
      console.log('index')
      console.log(this.rowIndexToBeUpdated)
      const deletedRowData = this.linkData[this.rowIndexToBeUpdated]
      deletedRowData.is_active = true
      // this.linkData.splice(this.rowIndexToBeUpdated, 1)
      // console.log('spliced linkData')
      console.log(this.linkData)
      const params = deletedRowData
      var self = this
      api.buildRequest('activatedLink', 'POST', params)
          .then(response => {
            self.loading = false
            self.rowIndexToBeUpdated = 0
            if (response.status === 200) {
              self.isDeleteConfirmationVisible = false
              this.$swal({
                type: 'success',
                text: response && response.data && response.data.payload && response.data.payload.message ? response.data.payload.message : 'Link activated successfully'
              })
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            self.closeModal()
            self.rowIndexToBeUpdated = 0
            self.isDeleteConfirmationVisible = false
            self.actionInProgress = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    getDataForSelectedPage (pageNum) {
      console.log('pageNum')
      console.log(pageNum)
      this.currentPage = pageNum
      this.getAllLink()
    },
    onChangePage (pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems
    },
    sortLink (sortKey, order) {
      this.linkData = _.sortBy(this.linkData, [sortKey])
      if (order === 'desc') {
        this.linkData = _.reverse(this.linkData)
      }
      console.log(`sorted keywords=${this.linkData}`)
    }
  },
  watch: {
    searchLink: function () {
      console.log('watching searchkeyowrd')
      if (this.searchLink === '') {
        this.getAllLink()
      }
    }
  },
  computed: {
    filteredList () {
      this.linkSearchResult = this.linkData.filter(keyword => {
        return keyword.id.toLowerCase().includes(this.searchLink.toLowerCase()) || keyword.data.name.toLowerCase().includes(this.searchLink.toLowerCase())
      })
      return this.linkSearchResult
    }
  }
}
</script>
<style>
.mrgn-right-20px {
  margin-right: 20px;
}
.loader {
  z-index: 9999;
  position: fixed;
  transform: translate(-50%,-50%);
  top:50%;
  left:50%;
}
.noaction {
  cursor: pointer;
  pointer-events: none;
}
.pagination {
  display: inline-block;
  margin-top: 0;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
}
.searchBox {
  width: 250px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding: 0 15px;
}
.margin-bottom-0px {
  margin-bottom: 0px; 
}
</style>


// WEBPACK FOOTER //
// linkList.vue?a5c280d0